import React from "react";

const TotalCurriculum = ({ color = "#464646" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1301_5362)">
        <path
          d="M18.4689 8.77701H15.2523C15.0388 8.77701 14.8656 8.60386 14.8656 8.39029C14.8656 8.17672 15.0388 8.00357 15.2523 8.00357H18.4689C18.6825 8.00357 18.8556 8.17672 18.8556 8.39029C18.8556 8.60386 18.6825 8.77701 18.4689 8.77701Z"
          fill={color}
        />
        <path
          d="M15.9671 6.63263H15.2523C15.0388 6.63263 14.8656 6.45948 14.8656 6.24591C14.8656 6.03234 15.0388 5.85919 15.2523 5.85919H15.9671C16.1807 5.85919 16.3539 6.03234 16.3539 6.24591C16.3539 6.45948 16.1807 6.63263 15.9671 6.63263Z"
          fill={color}
        />
        <path
          d="M20.4899 6.27523H18.1115C17.8979 6.27523 17.7248 6.10208 17.7248 5.88851V3.38672C17.7248 3.17314 17.8979 3 18.1115 3C18.3251 3 18.4982 3.17314 18.4982 3.38672V5.50179H20.4899C20.7035 5.50179 20.8766 5.67493 20.8766 5.88851C20.8766 6.10208 20.7035 6.27523 20.4899 6.27523Z"
         fill={color}
        />
        <path
          d="M20.6133 11.2788H13.1079C12.8944 11.2788 12.7212 11.1056 12.7212 10.8921V3.38672C12.7212 3.17314 12.8944 3 13.1079 3H18.1115C19.7042 3 21 4.29575 21 5.88851V10.8921C21 11.1057 20.8269 11.2788 20.6133 11.2788ZM13.4947 10.5053H20.2266V5.88851C20.2266 4.72223 19.2778 3.77344 18.1115 3.77344H13.4947V10.5053Z"
          fill={color}
        />
        <path
          d="M8.74766 8.77701H5.53111C5.31754 8.77701 5.14439 8.60386 5.14439 8.39029C5.14439 8.17672 5.31754 8.00357 5.53111 8.00357H8.74766C8.96124 8.00357 9.13438 8.17672 9.13438 8.39029C9.13438 8.60386 8.96124 8.77701 8.74766 8.77701Z"
         fill={color}
        />
        <path
          d="M6.24591 6.63263H5.53111C5.31754 6.63263 5.14439 6.45948 5.14439 6.24591C5.14439 6.03234 5.31754 5.85919 5.53111 5.85919H6.24591C6.45948 5.85919 6.63263 6.03234 6.63263 6.24591C6.63263 6.45948 6.45948 6.63263 6.24591 6.63263Z"
          fill={color}
        />
        <path
          d="M10.892 6.27523H8.39026C8.17668 6.27523 8.00354 6.10208 8.00354 5.88851V3.38672C8.00354 3.17314 8.17668 3 8.39026 3C8.60383 3 8.77698 3.17314 8.77698 3.38672V5.50179H10.892C11.1056 5.50179 11.2788 5.67493 11.2788 5.88851C11.2788 6.10208 11.1057 6.27523 10.892 6.27523Z"
          fill={color}
        />
        <path
          d="M10.8921 11.2788H3.38672C3.17314 11.2788 3 11.1056 3 10.8921V3.38672C3 3.17314 3.17314 3 3.38672 3H8.39026C9.98302 3 11.2788 4.29575 11.2788 5.88851V10.8921C11.2788 11.1057 11.1057 11.2788 10.8921 11.2788ZM3.77344 10.5053H10.5053V5.88851C10.5053 4.72227 9.55654 3.77344 8.39026 3.77344H3.77344V10.5053Z"
       fill={color}
        />
        <path
          d="M18.4689 18.4982H15.2523C15.0388 18.4982 14.8656 18.3251 14.8656 18.1115C14.8656 17.8979 15.0388 17.7248 15.2523 17.7248H18.4689C18.6825 17.7248 18.8556 17.8979 18.8556 18.1115C18.8556 18.3251 18.6825 18.4982 18.4689 18.4982Z"
         fill={color}
        />
        <path
          d="M15.9671 16.3538H15.2523C15.0388 16.3538 14.8656 16.1807 14.8656 15.9671C14.8656 15.7535 15.0388 15.5804 15.2523 15.5804H15.9671C16.1807 15.5804 16.3539 15.7535 16.3539 15.9671C16.3539 16.1807 16.1807 16.3538 15.9671 16.3538Z"
         fill={color}
        />
        <path
          d="M20.6133 15.9964H18.1115C17.8979 15.9964 17.7248 15.8233 17.7248 15.6097V13.1079C17.7248 12.8943 17.8979 12.7212 18.1115 12.7212C18.3251 12.7212 18.4982 12.8943 18.4982 13.1079V15.223H20.6133C20.8269 15.223 21 15.3961 21 15.6097C21 15.8233 20.8269 15.9964 20.6133 15.9964Z"
         fill={color}
        />
        <path
          d="M20.6133 21H13.1079C12.8944 21 12.7212 20.8269 12.7212 20.6133V13.108C12.7212 12.8944 12.8944 12.7213 13.1079 12.7213H18.1115C19.7042 12.7213 21 14.017 21 15.6098V20.6133C21 20.8269 20.8269 21 20.6133 21ZM13.4947 20.2266H20.2266V15.6097C20.2266 14.4435 19.2778 13.4947 18.1115 13.4947H13.4947V20.2266Z"
          fill={color}
        />
        <path
          d="M8.74766 18.4982H5.53111C5.31754 18.4982 5.14439 18.3251 5.14439 18.1115C5.14439 17.8979 5.31754 17.7248 5.53111 17.7248H8.74766C8.96124 17.7248 9.13438 17.8979 9.13438 18.1115C9.13438 18.3251 8.96124 18.4982 8.74766 18.4982Z"
          fill={color}
        />
        <path
          d="M6.24591 16.3538H5.53111C5.31754 16.3538 5.14439 16.1807 5.14439 15.9671C5.14439 15.7535 5.31754 15.5804 5.53111 15.5804H6.24591C6.45948 15.5804 6.63263 15.7535 6.63263 15.9671C6.63263 16.1807 6.45948 16.3538 6.24591 16.3538Z"
         fill={color}
        />
        <path
          d="M10.7668 15.9964H8.39026C8.17668 15.9964 8.00354 15.8233 8.00354 15.6097V13.1079C8.00354 12.8943 8.17668 12.7212 8.39026 12.7212C8.60383 12.7212 8.77698 12.8943 8.77698 13.1079V15.223H10.7668C10.9803 15.223 11.1535 15.3961 11.1535 15.6097C11.1535 15.8233 10.9803 15.9964 10.7668 15.9964Z"
          fill={color}
        />
        <path
          d="M10.8921 21H3.38672C3.17314 21 3 20.8269 3 20.6133V13.108C3 12.8944 3.17314 12.7213 3.38672 12.7213H8.39026C9.98302 12.7213 11.2788 14.017 11.2788 15.6098V20.6133C11.2788 20.8269 11.1057 21 10.8921 21ZM3.77344 20.2266H10.5053V15.6097C10.5053 14.4435 9.55654 13.4947 8.39026 13.4947H3.77344V20.2266Z"
         fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1301_5362">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(3 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TotalCurriculum;
